// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_gl-a";
export var fulfillmentFormRail = "_gl-9";
export var headerTitleRow = "_gl-c";
export var orderDetailsWrapper = "_gl-7";
export var orderLinkTrigger = "_gl-2";
export var paymentInformationGrid = "_gl-h";
export var paymentSummaryColumn = "_gl-i";
export var shipmentContainer = "_gl-b";
export var shipmentDetailsMainPane = "_gl-8";
export var shipmentNavigationCard = "_gl-5";
export var shipmentNavigationRail = "_gl-3";
export var shipmentNavigationRailHeader = "_gl-4";
export var shipmentSummaryFact = "_gl-e";
export var shipmentSummaryGrid = "_gl-d";
export var shipmentSummaryMetadataRow = "_gl-f";
export var shipmentSummaryTags = "_gl-g";
export var shipmentWorkspace = "_gl-0";
export var shipmentWorkspaceContent = "_gl-6";
export var shipmentWorkspaceHeader = "_gl-1";